export const modules = [
  {
    id: 1,
    title: 'Identidade',
    description: 'Descubra quem você é como líder e construa uma base sólida para sua jornada de liderança.',
    objectives: [
      'Autoconhecimento profundo',
      'Identificação de valores pessoais',
      'Construção de identidade de liderança',
      'Reconhecimento de forças e talentos'
    ],
    tools: ['Mapa de Identidade', 'Roda de Valores', 'Perfil de Liderança']
  },
  {
    id: 2,
    title: 'Autoliderança',
    description: 'Aprenda a liderar a si mesma antes de liderar os outros, desenvolvendo disciplina e autoconsciência.',
    objectives: [
      'Gestão emocional',
      'Desenvolvimento de disciplina',
      'Criação de rotinas produtivas',
      'Fortalecimento da autoconfiança'
    ],
    tools: ['Diário de Autoliderança', 'Plano de Desenvolvimento Pessoal', 'Tracker de Hábitos']
  },
  {
    id: 3,
    title: 'Propósito',
    description: 'Encontre seu propósito e alinhe suas ações profissionais com seus valores e missão de vida.',
    objectives: [
      'Descoberta de propósito',
      'Alinhamento de carreira e propósito',
      'Definição de missão pessoal',
      'Criação de visão de futuro'
    ],
    tools: ['Canvas de Propósito', 'Declaração de Missão', 'Mapa de Visão']
  },
  {
    id: 4,
    title: 'Mentalidade e Tempo',
    description: 'Desenvolva uma mentalidade de crescimento e domine a gestão do seu tempo para alcançar resultados extraordinários.',
    objectives: [
      'Mentalidade de crescimento',
      'Gestão estratégica do tempo',
      'Priorização eficaz',
      'Eliminação de crenças limitantes'
    ],
    tools: ['Matriz de Prioridades', 'Planner Estratégico', 'Mapa de Crenças']
  },
  {
    id: 5,
    title: 'Comunicação',
    description: 'Aprimore suas habilidades de comunicação para influenciar, inspirar e conectar-se autenticamente.',
    objectives: [
      'Comunicação assertiva',
      'Escuta ativa',
      'Storytelling impactante',
      'Comunicação não-verbal'
    ],
    tools: ['Framework de Comunicação', 'Guia de Storytelling', 'Checklist de Apresentações']
  },
  {
    id: 6,
    title: 'Posicionamento',
    description: 'Construa um posicionamento forte e autêntico que reflita sua essência e atraia as oportunidades certas.',
    objectives: [
      'Definição de marca pessoal',
      'Posicionamento estratégico',
      'Diferenciação no mercado',
      'Comunicação de valor'
    ],
    tools: ['Canvas de Marca Pessoal', 'Mapa de Posicionamento', 'Guia de Comunicação']
  },
  {
    id: 7,
    title: 'Networking',
    description: 'Desenvolva relacionamentos estratégicos e construa uma rede de contatos que impulsione sua carreira.',
    objectives: [
      'Networking estratégico',
      'Construção de relacionamentos',
      'Expansão de influência',
      'Colaboração efetiva'
    ],
    tools: ['Mapa de Rede', 'Plano de Networking', 'Guia de Relacionamentos']
  },
  {
    id: 8,
    title: 'Liderança de Times',
    description: 'Aprenda a liderar equipes de alta performance, inspirando e desenvolvendo pessoas ao seu redor.',
    objectives: [
      'Liderança de equipes',
      'Desenvolvimento de pessoas',
      'Gestão de conflitos',
      'Criação de cultura'
    ],
    tools: ['Framework de Liderança', 'Plano de Desenvolvimento de Time', 'Guia de Feedback']
  },
  {
    id: 9,
    title: 'Ego e Maturidade',
    description: 'Desenvolva maturidade emocional e aprenda a gerenciar seu ego para liderar com sabedoria e humildade.',
    objectives: [
      'Gestão do ego',
      'Maturidade emocional',
      'Humildade e aprendizado',
      'Resiliência'
    ],
    tools: ['Diário de Reflexão', 'Mapa de Maturidade', 'Guia de Autoavaliação']
  },
  {
    id: 10,
    title: 'Legado e Visão',
    description: 'Construa uma visão de longo prazo e defina o legado que deseja deixar como líder.',
    objectives: [
      'Visão de longo prazo',
      'Definição de legado',
      'Planejamento estratégico',
      'Impacto sustentável'
    ],
    tools: ['Mapa de Legado', 'Plano de Visão 10 Anos', 'Canvas de Impacto']
  }
];
